module.exports = __webpack_public_path__ + "img/xml.cd22fbbe.svg";